module.exports = __webpack_public_path__ + "img/si.e234414b.jpg";